import { createFileRoute } from '@tanstack/react-router';
import GlobalDataCollectionSettings from '../../../../../packages/tracker-settings-crate/components/GlobalAppSettings/GlobalDataCollectionSettings';

export const Route = createFileRoute('/_secured/administration/account/app/data-collection')({
  component: GlobalDataCollectionSettings,
});
